import React from 'react';
import { Dropdown as BootstrapDropdown } from 'react-bootstrap';

const Dropdown = ({ 
    title = 'Dropdown', 
    items = [], 
    variant = 'primary',
    size,
    split = false,
    isMobile = false, 
    isTablet = false, 
    isDesktop = false, 
    style, 
    className,
    ...props 
}) => {
    return (
        <BootstrapDropdown className={className} style={style} {...props}>
            <BootstrapDropdown.Toggle variant={variant} size={size} split={split}>
                {title}
            </BootstrapDropdown.Toggle>
            <BootstrapDropdown.Menu>
                {items.map((item, index) => {
                    if (item.divider) {
                        return <BootstrapDropdown.Divider key={index} />;
                    }
                    if (item.header) {
                        return <BootstrapDropdown.Header key={index}>{item.header}</BootstrapDropdown.Header>;
                    }
                    return (
                        <BootstrapDropdown.Item 
                            key={index}
                            onClick={item.onClick}
                            href={item.href}
                            active={item.active}
                            disabled={item.disabled}
                        >
                            {item.label || item.text || item}
                        </BootstrapDropdown.Item>
                    );
                })}
            </BootstrapDropdown.Menu>
        </BootstrapDropdown>
    );
};

export default Dropdown;

